/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "assets/css/index.css";
import userManager from "utils/userManager";
import { getTheme } from "@totalsoft/rocket-ui";
import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import PropTypes from "prop-types";
import { compose, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { loadApplicationTheme } from "features/branding/actionCreators";
import { camelize } from "utils/functions";

const ThemeProvider = ({ actions, children }) => {
  const [applicationTheme, setApplicationTheme] = useState({});
  const [themeIsLoaded, setThemeIsLoaded] = useState(false);

  useEffect(() => {
    userManager
      .signinSilent()
      .then(() => {
        loadApplicationTheme();
      })
      .catch(() => {
        userManager.signinRedirect({
          data: { redirectUrl: "/" }
        });
      });
  }, []);

  const loadApplicationTheme = () => {
    actions.loadApplicationTheme().then(data => {
      setApplicationTheme(data);
      setThemeIsLoaded(true);
    });
  };

  return themeIsLoaded ? (
    <MuiThemeProvider theme={getTheme({ globals: { theme: camelize(applicationTheme.themeName) } })}>
      {children}
    </MuiThemeProvider>
  ) : (
    <></>
  );
};

ThemeProvider.propTypes = {
  actions: PropTypes.object.isRequired,
  children: PropTypes.object
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        loadApplicationTheme
      },
      dispatch
    )
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(ThemeProvider);
